import { z } from 'zod';

/**
 * Montage-Kategorie (ADR 0053): verwaltbare Einsatz-Art mit Farbe für die
 * Timeline. Pflege durch Admins über den Daten-Editor — die API liefert nur
 * die Liste für Picker/Filter.
 */
export const assemblyCategoryResponseSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  /** Hex-Farbe (z. B. #059669) für Timeline-Balken und Badges. */
  color: z.string(),
  position: z.number().int(),
  isActive: z.boolean(),
});
export type AssemblyCategoryResponse = z.infer<typeof assemblyCategoryResponseSchema>;

/** Fallback-Farbe für Einsätze ohne (oder mit gelöschter) Kategorie. */
export const ASSEMBLY_DEFAULT_COLOR = '#64748b';

/** Option für den Techniker-Picker (aktive HR-Mitarbeiter). */
export const technicianOptionSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});
export type TechnicianOption = z.infer<typeof technicianOptionSchema>;
